module.exports = __webpack_public_path__ + "img/logo-fifalotto-white5-hanoy88.3a2b953f.png";